import sha256 from 'sha256'
export const crearHash = ({text}) => {

    let noEspacios = text.replaceAll(' ', '_')

    return sha256(noEspacios)

}